export default "__VITE_ASSET__Ds7r2rg3__"